module.exports = __webpack_public_path__ + "static/media/psychology.8dc61ed8.jpg";